import React from 'react';

import { About, Footer, Header, Education, Projects, SkillsAndExperience} from './container';
import { Navbar } from './components';
import './App.scss';

const App = () => {
    return (
        // <h1 className="app">APP</h1>
        <div className="app">
            <Navbar />
            <Header />
            <About />
            <Education/>
            <SkillsAndExperience />
            <Projects/>
            <Footer />
        </div>
    );
  
  

} 

export default App;